import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelTextArea } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import HomologacaoRouterboard from '../../../models/HomologacaoRouterboard';
import RouterboardTipoEnum    from '../../../enums/RouterboardTipoEnum';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {    
    descricao: {
        exibir:    'main.homologacaorouterboard.descricao',
        visivel:   true,
        validacao: { obrigatorio: true },
    },
    versao: {
        exibir:    'main.homologacaorouterboard.versao',
        visivel:   true,
        validacao: { obrigatorio: true },
    },
    tipo: {
        exibir:    'main.homologacaorouterboard.tipo',
        visivel:   true,
        tipo:      'enum',
        entidade:  'routerboard.tipo',
        validacao: { obrigatorio: true },
    },
    homologadoem: {
        exibir:  'main.homologacaorouterboard.homologadoem',
        visivel: true,
        tipo:    'date',
    },
    comandoprovisionamento: {
        exibir:    'main.homologacaorouterboard.comandoprovisionamento',
        validacao: { obrigatorio: true },
    },
    comandoonconnect: {
        exibir: 'main.homologacaorouterboard.comandoonconnect',
    },
    comandoondisconnect: {
        exibir: 'main.homologacaorouterboard.comandoondisconnect',
    },
    comandoativarapi: {
        exibir: 'main.homologacaorouterboard.comandoativarapi',
    },
    comandoativarsslletsencrypt: {
        exibir: 'main.homologacaorouterboard.comandoativarsslletsencrypt',
    },
    templatealogin: {
        exibir:    'main.homologacaorouterboard.templatealogin',
        validacao: { obrigatorio: true },
    },
    templatelogin: {
        exibir:    'main.homologacaorouterboard.templatelogin',
        validacao: { obrigatorio: true },
    },
    templateredirect: {
        exibir:    'main.homologacaorouterboard.templateredirect',
        validacao: { obrigatorio: true },
    },
    templateapi: {
        exibir:    'main.homologacaorouterboard.templateapi',
        validacao: { obrigatorio: true },
    },
    templatestatus: {
        exibir:    'main.homologacaorouterboard.templatestatus',
        validacao: { obrigatorio: true },
    },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const renderers = {
    'routerboard.tipo': RouterboardTipoEnum,
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

class HomologacaoRouterboardFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
                <TabPanel header={UtilService.traduzir('main.homologacaorouterboard.aba.basica')} leftIcon="pi pi-home mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.descricao} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.versao} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelDropDown model={model.tipo} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelCalendar model={model.homologadoem} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={UtilService.traduzir('main.homologacaorouterboard.aba.comandos')} leftIcon="pi pi-terminal mr-2">
                    <div className="grid">
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={model.comandoprovisionamento} contexto={contexto} rows={8} />
                        </div>
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={model.comandoonconnect} contexto={contexto} rows={8} />
                        </div>
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={model.comandoondisconnect} contexto={contexto} rows={8} />
                        </div>
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={model.comandoativarapi} contexto={contexto} rows={8} />
                        </div>
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={model.comandoativarsslletsencrypt} contexto={contexto} rows={8} />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={UtilService.traduzir('main.homologacaorouterboard.aba.templates')} leftIcon="pi pi-code mr-2">
                    <div className="grid">
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={model.templatealogin} contexto={contexto} rows={5} />
                        </div>
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={model.templatelogin} contexto={contexto} rows={5} />
                        </div>
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={model.templateredirect} contexto={contexto} rows={5} />
                        </div>
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={model.templateapi} contexto={contexto} rows={5} />
                        </div>
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={model.templatestatus} contexto={contexto} rows={5} />
                        </div>
                    </div>
                </TabPanel>
            </TabViewComErro>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class HomologacaoRouterboardTemplate extends Component {

    processos() {
        return [{
            label:    'main.duplicar',
            icon:     'pi pi-clone',
            disabled: true,
            ativo: (processo, selected) => {
                processo.disabled = selected.length !== 1;
                return processo;
            },
            command: () => { this.gridRef?.duplicar(); },
        }];
    }

    render() {
        return (
            <EntityGrid
                ref={(ref) => this.gridRef = ref}
                entidade={HomologacaoRouterboard}
                model={model}
                identidade="main.homologacaorouterboard"
                permissoes={this.props.permissoes}
                icone="pi-verified"
                storageKey="dt-homologacaorouterboards"
                ocultarColunaPublicacao // catalogo global (naofiltrarpublicacao:true no model backend)
                processos={this.processos()}
                renderers={renderers}
                configuracao={this.props.configuracao}
                navigate={this.props.navigate}
                location={this.props.location}
                searchparams={this.props.searchparams}
                formulario={(m, ctx) => <HomologacaoRouterboardFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default HomologacaoRouterboardTemplate;
